<template>
	<div class="patent_apply">
		<div class="patent_title">长三角地区PCT专利申请量</div>
		<div id="barChart8" style="width:100%;height:100px;"></div>
		<div id="barChart9" style="width:100%;height:170px;"></div>
	</div>
</template>
<script>
	export default {
		data() {
			return {

			}
		},
		mounted() {

		},
		methods: {
			getData(list1, list2) {
				this.drowChart8(list1);
				this.drowChart9(list2);
			},
			drowChart8(list1) {
				let myChart = this.$echarts.init(document.getElementById('barChart8'));
				var option = {
					legend: {
						data: ['PCT申请增幅(%)'],
						x: 'center', // 对齐方式
						textStyle: {
							color: 'rgba(255,255,255,0.6)',
							fontSize: 14,
							fontWeight: 400,
						},
					},
					grid: {
						top: '40%',
						left: '0',
						right: '0',
						bottom: '0'
					},
					tooltip: {
						trigger: 'axis',
						axisPointer: {
					  type: 'cross',
							crossStyle: {
								color: 'red'
							},
							lineStyle: {
								color: 'red'
							}
						}
					},
					xAxis: {
						show: false,
						data:list1.map(item =>item.name),
					},
					yAxis: {
						show: false, //Y轴坐标线隐藏
						type: 'value',
						axisLabel: { //Y轴隐藏过后产生留白
							formatter: function() {
								return "";
							}
						}
					},
					series: [{
						data:list1.map(item =>item.value),
						type: 'line',
						name: 'PCT申请增幅(%)',
						symbolSize: 14, // 控制线条上 点 的大小
						symbol: 'circle', //折线点设置为实心点
						itemStyle: {
							normal: {
								label: {
									show: true,
									fontSize: 16,
								},
								color: '#FAAD14',
							}
						}
					}]
				};
				myChart.setOption(option);
				window.addEventListener("resize", function() {
					myChart.resize();
				});
			},
			drowChart9(list2) {
				let myChart = this.$echarts.init(document.getElementById('barChart9'));
				var option = {
					legend: {
						data: ['PCT专利申请量(件)'],
						itemWidth: 10,
						itemHeight: 10,
						top: '5%',
						bottom: '1%',
						left: 'center',
						itemGap: 50, // item之间的距离
						textStyle: {
							color: 'rgba(255,255,255,0.6)',
							fontSize: 14,
							fontWeight: 400,
						},
					},
					grid: {
						left: '0',
						right: '0',
						top: '30%',
						bottom: '0',
						containLabel: true
					},
					tooltip: {
						trigger: 'axis',
						axisPointer: {
							type: 'cross',
							crossStyle: {
								color: 'red'
							},
							lineStyle: {
								color: 'red'
							}
						}
					},
					textStyle: {
						color: '#fff',
					},
					xAxis: {
						type: 'category',
						axisLine: {
							show: true,
						},
						axisTick: {
							alignWithLabel: true
						},
						axisLabel: {
							interval: 0, //数据过多时不间隔显示名称
						},
						data:list2.map(item =>item.name),
					},
				 yAxis: {
						show: false, //Y轴坐标线隐藏
						type: 'value',
						axisLabel: { //Y轴隐藏过后产生留白
							formatter: function() {
								return "";
							}
						}
					},
					color: [{
						type: 'linear',
						x: 0,
						y: 0,
						x2: 0,
						y2: 1,
						colorStops: [{
								offset: 0,
								color: '#09E897'
							}, // 设置颜色渐变
							{
								offset: 1,
								color: '#508DDB'
							}
						]
					}, ],
					series: [{
						data:list2.map(item =>item.value),
						type: 'bar',
						name: 'PCT专利申请量(件)',
						barWidth: '30%',
						barGap: '10%',
						label: {
							show: true,
							position: 'outside',
							color: '#fff'
						},

					}, ]
				};
				myChart.setOption(option);
				window.addEventListener("resize", function() {
					myChart.resize();
				});
			},
		}
	}
</script>
